import PropTypes from "prop-types";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";

const H4 = ({ children }) => (
    <TextStyles
        as="h4"
        textStyles={["Myriad Pro/18-100-semibold-semiextended", null, null, null, null, "Myriad Pro/20-100-semibold"]}
    >
        {children}
    </TextStyles>
);

H4.propTypes = {
    children: PropTypes.node.isRequired,
};

export default H4;
